import React from 'react';
import { Card, CardBody, CardHeader, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { P, H5 } from '../../../../AbstractElements';
import { Contact, Hometxt, Profile } from '../../../../Constant';
import TabsPreventDefaultAndAnimation from '../../../../Hoc/TabsPreventDefaultAndAnimation';

const Comontab = ({ show, tabActive, tabActiveHandler, title, pare, icone, navclass }) => {
  return (
    <Col lg='12 box-col-12' xl='6 xl-100'>
      <Card>
        <CardHeader>
          <H5>{title}</H5>
        </CardHeader>
        <CardBody>
          <div className='tabbed-card'>
            <Nav className={navclass}>
              <NavItem>
                <NavLink href='#javascript' className={tabActive === '1' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                  {icone.homeIcon && icone.homeIcon}
                  {Hometxt}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='#javascript' className={tabActive === '2' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '2')}>
                  {icone.Profile && icone.Profile}
                  {Profile}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='#javascript' className={tabActive === '3' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                  {icone.contactIcon && icone.contactIcon}
                  {Contact}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={tabActive}>
              <TabPane className={`fade ${tabActive === '1' ? show : ''}`} tabId='1'>
                <P className='mb-0'>{pare}</P>
              </TabPane>
              <TabPane className={`fade ${tabActive === '2' ? show : ''}`} tabId='2'>
                <P className='mb-0'>{pare}</P>
              </TabPane>
              <TabPane className={`fade ${tabActive === '3' ? show : ''}`} tabId='3'>
                <P className='mb-0'>{pare}</P>
              </TabPane>
            </TabContent>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(Comontab);
